import { animate, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { TARGET_SOFTWARE_ICONS, WORKROADS } from 'src/app/core/constants/software-info';
import { TrackedChange } from 'src/app/core/definitions/enums';
import { ID } from 'src/app/core/definitions/types';
import { IntegrationDetail, WORKROADS_INTEGRATION } from 'src/app/core/interfaces/integration-detail.interface';
import { enumToString } from 'src/app/core/models/integration.model';

@Component({
  selector: 'app-integration-card',
  templateUrl: './integration-card.component.html',
  styleUrls: ['./integration-card.component.scss'],
  animations: [
    trigger('inOutAnimation', [
      transition(':enter', [
        style({ height: 0, opacity: 0 }),
        animate('.3s ease-out', style({ height: 250, opacity: 1 }))
      ]),
      transition(':leave', [
        style({ height: 250, opacity: 1 }),
        animate('.2s ease-in', style({ height: 0, opacity: 0 }))
      ])
    ])
  ]
})
export class IntegrationCardComponent implements OnInit, OnDestroy, OnChanges {


  isEditing = false;
  @Input() integration!: IntegrationDetail;
  @Input() isNew = false;
  @Input() status: string | null = null; // If null loading

  @Output() submit = new EventEmitter<IntegrationDetail>();
  @Output() delete = new EventEmitter<ID>();
  @Output() discard = new EventEmitter<ID>();

  cardForm!: FormGroup;

  private onDestroy$ = new Subject<void>();


  constructor(private fb: FormBuilder) { }

  info = TARGET_SOFTWARE_ICONS[WORKROADS];

  ngOnInit(): void {
    this.cardForm = this.fb.group({
      name: new FormControl(this.integration.name, Validators.required),
      connectionString: new FormControl(this.integration.connectionString, [
        Validators.required,
        // Validators.pattern(CODE_NAME_REGEX) Probably Coming
      ]),
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // We need onChanges to handle discard actions
    if (changes.integration) {
      if (changes.integration.firstChange) return;
      if (changes.integration.currentValue.trackedChange !== TrackedChange.Unmodified)
        return;
      this.cardForm.patchValue({ ...changes.integration.currentValue }, { emitEvent: false });
    }
  }

  toggle(): void {
    this.setEditable(!this.isEditing);
  }

  setEditable(value: boolean): void {
    this.isEditing = value;
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  get isFormValid() {
    return this.cardForm.valid;
  }


  get formHasChange() {
    return this.cardForm.dirty;
  }

  get isConnectionStringDirty() {
    return this.cardForm.get('connectionString')?.dirty;
  }


  clickedOutsideCard($event: boolean) {
  }

  get typeDisplay() {
    return enumToString(this.integration.type ?? WORKROADS_INTEGRATION.type);
  }

  onDelete() {
    this.delete.emit(this.integration.id);
  }

  onDiscard() {
    this.cardForm.reset(this.integration);
    if (this.isNew) {
      this.delete.emit(this.integration.id);
    }
  }
  onSubmit() {
    this.submit.emit(this.cardForm.value);
    this.toggle();
  }

}
